import React, { Children, ReactNode } from 'react';
import Revolve from './Revolve';
import './style.css';

interface WheelProps {
    /**
     * Items in the wheel
     */
    children: ReactNode;
    /**
     * Diameter of the wheel
     */
    diameter: number;
}
/**
 * Displays its children in a wheel
 * The children will be placed along the wheel's circumference
 */
const Wheel = ({ children, diameter }: WheelProps) => <g className="svg-wheel">
    {Children.map(children, (child, i) => <Revolve
        angle={Math.PI * ((i / Children.count(children) * 2) - .5)}
        offset={diameter / 2}>
        {child}
    </Revolve>)}
</g>;

export default Wheel;
